module.exports = __webpack_public_path__ + "img/RECUADRO_Support.6892ff70.png";